import { connect } from 'react-redux'
import ServiceCreatePane from '../../components/services/edit/ServiceCreatePane'
import { actionCreators } from '../../state/actions/services/index'
import { IServiceEditStepData, IStoreState } from '../../types/index'

const firstStep: IServiceEditStepData = {
  position: 0,
  fetching: false,
  fetchingError: '',
  updating: false,
  updatingError: '',
  changed: false
}

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  const stepPosition = state.serviceEdit.steps.currentStep.position
  return {
    step: stepPosition >= 0 ? state.serviceEdit.steps.list[stepPosition] : null,
    stepData: state.serviceEdit.steps.currentStep,
    history: ownProps.history,
    zones: state.goinzones.items
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    onComponentMount: () => {
      dispatch(actionCreators.serviceEditClearState())
      dispatch(actionCreators.serviceCreateSetCurrentStep(firstStep))
    },
    onStepCompleted: (position: number) => {
      const nextPosition = position + 1
      dispatch(
        actionCreators.serviceCreateSetCurrentStep({
          position: nextPosition,
          fetching: false,
          fetchingError: '',
          updating: false,
          updatingError: '',
          changed: false
        })
      )
    },
    onHideErrorClick: () => {
      dispatch(actionCreators.serviceCreateSetFetchingError(''))
      dispatch(actionCreators.serviceCreateSetUpdatingError(''))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceCreatePane)



// WEBPACK FOOTER //
// ./src/containers/services/ServiceCreatePane.ts